/**
 * Booking Services Module
 * Exports all booking management services and factory functions
 */
// Export all service classes
export { BookableResourceService } from './BookableResourceService';
export { BookableResourceTypeService } from './BookableResourceTypeService';
export { BookableResourceStatusService } from './BookableResourceStatusService';
export { BookableResourceImageService } from './BookableResourceImageService';
export { BookableResourceBlockoutService } from './BookableResourceBlockoutService';
export { BookableResourceBlockoutTypeService } from './BookableResourceBlockoutTypeService';
export { BookingService } from './BookingService';
export { BookingStatusService } from './BookingStatusService';
export { BookingLogService } from './BookingLogService';
export { BookingAccessoryService } from './BookingAccessoryService';
export { BookingSettingService } from './BookingSettingService';
export { BookingLogMediaService } from './BookingLogMediaService';
export { BookingStatusHistoryService } from './BookingStatusHistoryService';
export { BookableResourceNoteService } from './BookableResourceNoteService';
export { BookingRecurrenceService } from './BookingRecurrenceService';
export { BookingWaitlistService } from './BookingWaitlistService';
export { BookingInventoryAuditService } from './BookingInventoryAuditService';
export { BookingPlatformSettingsService } from './BookingPlatformSettingsService';
// Re-export shared types from the scan/tracker additions on BookableResourceService
export { ScanType } from './BookableResourceService';
// Import for factory function
import { BookableResourceService } from './BookableResourceService';
import { BookableResourceTypeService } from './BookableResourceTypeService';
import { BookableResourceStatusService } from './BookableResourceStatusService';
import { BookableResourceImageService } from './BookableResourceImageService';
import { BookableResourceBlockoutService } from './BookableResourceBlockoutService';
import { BookableResourceBlockoutTypeService } from './BookableResourceBlockoutTypeService';
import { BookingService } from './BookingService';
import { BookingStatusService } from './BookingStatusService';
import { BookingLogService } from './BookingLogService';
import { BookingAccessoryService } from './BookingAccessoryService';
import { BookingSettingService } from './BookingSettingService';
import { BookingLogMediaService } from './BookingLogMediaService';
import { BookingStatusHistoryService } from './BookingStatusHistoryService';
import { BookableResourceNoteService } from './BookableResourceNoteService';
import { BookingRecurrenceService } from './BookingRecurrenceService';
import { BookingWaitlistService } from './BookingWaitlistService';
import { BookingInventoryAuditService } from './BookingInventoryAuditService';
import { BookingPlatformSettingsService } from './BookingPlatformSettingsService';
/**
 * Create all booking services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all booking service instances
 */
export function createBookingServices(http, config) {
    return {
        bookableResource: new BookableResourceService(http, config),
        bookableResourceType: new BookableResourceTypeService(http, config),
        bookableResourceStatus: new BookableResourceStatusService(http, config),
        bookableResourceImage: new BookableResourceImageService(http, config),
        bookableResourceBlockout: new BookableResourceBlockoutService(http, config),
        bookableResourceBlockoutType: new BookableResourceBlockoutTypeService(http, config),
        booking: new BookingService(http, config),
        bookingStatus: new BookingStatusService(http, config),
        bookingLog: new BookingLogService(http, config),
        bookingAccessory: new BookingAccessoryService(http, config),
        bookingSetting: new BookingSettingService(http, config),
        bookingLogMedia: new BookingLogMediaService(http, config),
        bookingStatusHistory: new BookingStatusHistoryService(http, config),
        bookableResourceNote: new BookableResourceNoteService(http, config),
        bookingRecurrence: new BookingRecurrenceService(http, config),
        bookingWaitlist: new BookingWaitlistService(http, config),
        bookingInventoryAudit: new BookingInventoryAuditService(http, config),
        bookingPlatformSettings: new BookingPlatformSettingsService(http, config),
    };
}
//# sourceMappingURL=index.js.map